function ImageGrid({ images, columns }) {
    if (!images || images.length === 0) return null;
    const cols = columns || { default: 2, md: 3 };

    return (
        <div className={`grid grid-cols-${cols.default} md:grid-cols-${cols.md} gap-4`}>
            {images.map((src, i) => (
                <div key={i} className="h-48 w-full">
                    <img src={src} alt="gallery" className="object-cover h-48 w-full rounded-md" />
                </div>
            ))}
        </div>
    );
}

export default ImageGrid;
